<template>
  <div class="root">
    <img :src="imgSrc" />
  </div>
</template>

<script>
import dateFormat from 'dateformat'
import axios from 'axios'
import BaseComponent from '@/components/BaseComponent'

export default {
  name: 'ImageView',
  extends: BaseComponent,
  props: {
    fileName: String
  },
  data () {
    return {
      imgSrc: '',
      lastModified: '',
      intervalId: null
    }
  },
  created () {
    if (this.isDistanceValidated()) {
      this.loadImageIfModified()
      this.startAutoReloading()
    } else {
      this.$router.push({ name: 'Caution' })
    }
  },
  beforeDestroy () {
    this.stopAutoReloading()
  },
  methods: {
    startAutoReloading () {
      if (!this.intervalId) {
        this.intervalId = window.setInterval(this.loadImageIfModified, 10 * 1000)
      }
    },
    stopAutoReloading () {
      if (this.intervalId) {
        window.clearInterval(this.intervalId)
      }
    },
    loadImage () {
      // img要素にリロードさせるためにURLパラメーターをつける
      let url = this.createImageUrl()
      let dt = dateFormat(new Date(), 'isoDateTime')
      this.imgSrc = `${url}?dt=${dt}`
    },
    loadImageIfModified () {
      this.getImageLastModified().then(lastModified => {
        if (lastModified !== this.lastModified) {
          this.lastModified = lastModified
          this.loadImage()
        }
      }).catch(err => {
        this.stopAutoReloading()
        if (err.name === 'NotFound') {
          this.$router.push({ name: 'NotFound' })
        } else {
          window.console.log(err)
        }
      })
    },
    getImageLastModified () {
      let url = this.createImageUrl()
      return axios.head(url).then(res => {
        // Webサーバー側のSPA対応で、Not Foundの場合は /index.html が返る。
        let contentType = res.headers['content-type']
        if (contentType && contentType.startsWith('text/html')) {
          let err = new Error('Image not found.')
          err.name = 'NotFound'
          throw err
        }

        return res.headers['last-modified']
      })
    },
    createImageUrl () {
      let url = `/generated_images/K22/${this.fileName}`

      return url
    }
  }
}
</script>

<style lang="scss" scoped>
.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  img {
    display: block;
    width: 100%;
  }
}
</style>
